"use strict";

exports.__esModule = true;
exports["default"] = exports.ComparisonTable = exports.ButtonsContainer = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _ramda = require("ramda");

var _styles = require("@qc-modules/styles");

var _primitives = _interopRequireDefault(require("../../primitives"));

var _utils = require("../../utils");

var _table = require("./table");

var _footnotes = require("./footnotes");

var _gridSystem = _interopRequireDefault(require("../../utils/grid-system"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var TableWrapper = _styledComponents["default"].div.withConfig({
  displayName: "comparison-table__TableWrapper",
  componentId: "sc-72rnxj-0"
})(["position:relative;overflow-x:auto;overflow-y:hidden;-webkit-overflow-scrolling:touch;", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme && theme.breakpointInts ? (0, _styledComponents.css)(["@media (min-width:", "px){&::-webkit-scrollbar{height:8px;}&::-webkit-scrollbar-track{background:#e9ecef;border-radius:4px;}&::-webkit-scrollbar-thumb{background:#7a7a7a;border-radius:4px;}}"], theme.breakpointInts[0]) : null;
});

var FirstColumnContainer = (0, _styledComponents["default"])(_primitives["default"].Box).withConfig({
  displayName: "comparison-table__FirstColumnContainer",
  componentId: "sc-72rnxj-1"
})(["", ";"], function (_ref2) {
  var theme = _ref2.theme;
  return theme && theme.breakpointInts ? (0, _styledComponents.css)(["@media (max-width:", "px){max-width:150px;}"], theme.breakpointInts[0] - 1) : null;
});
var ButtonsContainer = (0, _styledComponents["default"])(_primitives["default"].Box).withConfig({
  displayName: "comparison-table__ButtonsContainer",
  componentId: "sc-72rnxj-2"
})(["background:transparent;opacity:", ";fill:", ";"], function (props) {
  return props.disabled ? "0.3" : "1";
}, function (props) {
  return (0, _styles.colors)("icon-input", props);
});
exports.ButtonsContainer = ButtonsContainer;

var Wrapper = _styledComponents["default"].div.withConfig({
  displayName: "comparison-table__Wrapper",
  componentId: "sc-72rnxj-3"
})(["max-width:100%;width:100%;"]);

var propTypes = {
  /** Background color */
  backgroundColor: _propTypes.string,

  /** setting for bottom padding amount * */
  bottomUnitPadding: _propTypes.number,

  /** An array of titles for categories */
  categories: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    id: (0, _propTypes.oneOfType)([_propTypes.array, _propTypes.number, _propTypes.string]),
    name: _propTypes.string
  })),

  /** String for content color of text of cell  */
  cellColor: _propTypes.string,

  /** String for class to pass to component */
  className: _propTypes.string,

  /** Custom Background React component  */
  customBackground: _propTypes.func,

  /** An array of products for display */
  data: (0, _propTypes.arrayOf)(_propTypes.object),

  /** Array of disclaimer strings  */
  disclaimers: (0, _propTypes.arrayOf)(_propTypes.string),

  /** Node for cta * */
  downloadCta: _propTypes.node,

  /** An array of footnotes to display below table */
  footnotes: (0, _propTypes.arrayOf)(_propTypes.string),

  /** String for id to pass to component */
  htmlId: _propTypes.string,

  /** theme object */
  theme: _utils.themePropType,

  /** Title text usually a text, but can be a React component  */
  title: _propTypes.node,

  /** String for title color */
  titleColor: _propTypes.string,

  /** setting for top padding amount * */
  topUnitPadding: _propTypes.number
};
var titleFont = {
  color: "title",
  fontSize: 10,
  fontWeight: 2,
  lineHeight: 2,
  mb: 3,
  textAlign: "center"
};
var productFont = {
  color: "text-link",
  fontSize: 4,
  fontWeight: 1,
  justifyContent: "flex-start",
  lineHeight: 2,
  mb: 0,
  textAlign: "left"
};
var defaultProps = {
  backgroundColor: "background",
  bottomUnitPadding: 2,
  cellColor: "text",
  titleColor: "light-gunmetal",
  topUnitPadding: 2
};

var ComparisonTable = function ComparisonTable(_ref3) {
  var backgroundColor = _ref3.backgroundColor,
      bottomUnitPadding = _ref3.bottomUnitPadding,
      categories = _ref3.categories,
      cellColor = _ref3.cellColor,
      className = _ref3.className,
      customBackground = _ref3.customBackground,
      data = _ref3.data,
      disclaimers = _ref3.disclaimers,
      downloadCta = _ref3.downloadCta,
      footnotes = _ref3.footnotes,
      htmlId = _ref3.htmlId,
      theme = _ref3.theme,
      title = _ref3.title,
      titleColor = _ref3.titleColor,
      topUnitPadding = _ref3.topUnitPadding;

  var _useState = (0, _react.useState)(2000),
      columnWidth = _useState[0],
      setColumnWidth = _useState[1];

  var _useState2 = (0, _react.useState)([]),
      rowHeights = _useState2[0],
      setRowHeights = _useState2[1];

  var _useState3 = (0, _react.useState)(1),
      tableHeight = _useState3[0],
      setTableHeight = _useState3[1];

  var componentRef = (0, _react.useRef)(null);
  var containerRef = (0, _react.useRef)(null);
  var columnRef = (0, _react.useRef)(null);
  var rowRefs = (0, _react.useRef)((0, _ramda.map)(function () {
    return /*#__PURE__*/(0, _react.createRef)();
  }, (0, _ramda.prepend)({}, data)));
  var updateHeights = (0, _react.useCallback)(function () {
    var newRowHeights = (0, _ramda.reduce)(function (acc, row) {
      return [].concat(acc, [row.current.offsetHeight]);
    }, [], rowRefs.current);
    var containerWidth = containerRef.current.clientWidth - componentRef.current.clientWidth;
    setColumnWidth(containerWidth / 2 + componentRef.current.clientWidth - columnRef.current.clientWidth);
    setRowHeights(newRowHeights);
    setTableHeight((0, _ramda.reduce)(_ramda.add, 48, (0, _ramda.values)(newRowHeights)) + (0, _ramda.values)(newRowHeights).length);
  }, [containerRef, componentRef, columnRef, rowRefs]);
  (0, _react.useEffect)(function () {
    window.addEventListener("resize", updateHeights);
    window.addEventListener("DOMContentLoaded", updateHeights);
    updateHeights();
    return function () {
      window.removeEventListener("resize", updateHeights);
      window.removeEventListener("DOMContentLoaded", updateHeights);
    };
  }, [updateHeights]);

  var _useMemo = (0, _react.useMemo)(function () {
    return {
      cellFont: {
        color: cellColor,
        fontSize: [2, 1, 1, 1, 1, 2],
        fontWeight: 1,
        lineHeight: 3,
        mb: 0,
        textAlign: "left"
      },
      typeFont: {
        color: cellColor,
        fontSize: 2,
        fontWeight: 1,
        lineHeight: 2,
        mb: 0,
        textAlign: "left"
      }
    };
  }, [cellColor]),
      typeFont = _useMemo.typeFont,
      cellFont = _useMemo.cellFont;

  var _useMemo2 = (0, _react.useMemo)(function () {
    return {
      cellTitleFont: {
        color: titleColor,
        fontSize: [2, 1, 1, 1, 1, 2],
        fontWeight: 2,
        lineHeight: 2,
        mb: 0,
        textAlign: "left"
      },
      productTitleFont: {
        color: titleColor,
        fontSize: [2, 1, 1, 1, 1, 2],
        fontWeight: 2,
        lineHeight: 2,
        mb: 0,
        textAlign: "center"
      }
    };
  }, [titleColor]),
      cellTitleFont = _useMemo2.cellTitleFont,
      productTitleFont = _useMemo2.productTitleFont;

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: className,
    "data-test-id": "modules-comparison-table",
    id: htmlId,
    ref: containerRef
  }, /*#__PURE__*/_react["default"].createElement(_gridSystem["default"].Wrapper, {
    as: customBackground,
    backgroundColor: backgroundColor,
    flexDirection: "column"
  }, /*#__PURE__*/_react["default"].createElement(Wrapper, {
    ref: componentRef
  }, /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, {
    alignItems: "center",
    flexDirection: "column",
    justifyContent: "center",
    pb: theme && theme.unitPadding && theme.unitPadding.map(function (padding) {
      return bottomUnitPadding * padding;
    }),
    pt: theme && theme.unitPadding && theme.unitPadding.map(function (padding) {
      return topUnitPadding * padding;
    }),
    width: 1
  }, /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, {
    flexDirection: "column",
    width: 1
  }, /*#__PURE__*/_react["default"].createElement(_primitives["default"].Text, _extends({
    "data-test-id": "modules-comparison-table-title",
    tag: "h2",
    textAlign: "center"
  }, titleFont), title), downloadCta && /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, {
    justifyContent: "flex-end",
    mb: 3
  }, downloadCta)), /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, {
    alignItems: "flex-start",
    justifyContent: "flex-start",
    width: 1
  }, /*#__PURE__*/_react["default"].createElement(FirstColumnContainer, null, /*#__PURE__*/_react["default"].createElement("div", {
    ref: columnRef
  }, /*#__PURE__*/_react["default"].createElement(_table.FirstColumn, {
    data: data,
    productFont: productFont,
    productTitleFont: productTitleFont,
    rowHeights: rowHeights,
    typeFont: typeFont
  }))), /*#__PURE__*/_react["default"].createElement(_primitives["default"].Box, {
    position: "relative"
  }, /*#__PURE__*/_react["default"].createElement(TableWrapper, {
    style: {
      height: tableHeight,
      width: columnWidth
    }
  }, /*#__PURE__*/_react["default"].createElement(_table.ScrollableTable, {
    categories: categories,
    cellFont: cellFont,
    cellTitleFont: cellTitleFont,
    data: data,
    rowRefs: rowRefs
  })))), footnotes && /*#__PURE__*/_react["default"].createElement(_footnotes.Footnotes, {
    footnotes: footnotes
  }), disclaimers && /*#__PURE__*/_react["default"].createElement(_footnotes.Disclaimer, {
    disclaimers: disclaimers
  })))));
};

exports.ComparisonTable = ComparisonTable;
ComparisonTable.defaultProps = defaultProps;
ComparisonTable.propTypes = propTypes;
ComparisonTable.displayName = "Modules.ComparisonTable";

var _default = (0, _styledComponents.withTheme)(ComparisonTable);

exports["default"] = _default;